import { SubTrayItemProductDetails } from 'lib/services/api/product-service/receiveItems/types'
import { SubItem } from 'common/types'

/**
 * Parses product details from either a JSON string or an existing object
 * @param productDetails - The product details to parse
 * @returns Parsed product details or undefined if invalid
 */
const parseProductDetails = (
  productDetails: string | object | null | undefined
): SubTrayItemProductDetails | undefined => {
  if (!productDetails) {
    return undefined
  }

  try {
    // If it's already an object, return it as is
    if (typeof productDetails === 'object') {
      return productDetails as SubTrayItemProductDetails
    }

    // If it's a string, parse it
    if (typeof productDetails === 'string') {
      return JSON.parse(productDetails) as SubTrayItemProductDetails
    }

    return undefined
  } catch (error) {
    console.error('Error parsing sub-tray product details:', error)
    return undefined
  }
}

/**
 * Extracts and parses sub-tray JSON data from a SubItem
 * @param subItem - The sub-item to extract data from
 * @returns Parsed sub-tray product details or undefined if invalid/missing
 */
export const extractSubTrayJSONData = (
  subItem: SubItem | undefined | null
): SubTrayItemProductDetails | undefined => {
  if (!subItem) {
    return undefined
  }

  return parseProductDetails(subItem.productDetails)
}
